module.exports = __webpack_public_path__ + "static/media/400019_02.70787893.png";